import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ThemeModal from './ThemeModal';
import ActivationModal from './ActivationModal';

export default function ThemeActions({ themes = [], themeId, sectionFor = 1, onCreated }) {
  const [creating, setCreating] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const selected = themes.find(theme => Number(theme.id) === Number(themeId));
  return <>
    <Button size="sm" variant="outline-primary" onClick={() => setCreating(true)}>+ Create theme</Button>
    <Button size="sm" variant="success" disabled={!selected || Number(selected.status) !== 1} onClick={() => setPublishing(true)}>Publish / schedule</Button>
    <Button as={Link} size="sm" variant="outline-secondary" to={`/admin/designs/themes?platform=2&page=${sectionFor}`}>Manage themes</Button>
    {creating && <ThemeModal show onClose={() => setCreating(false)} onSaved={async theme => { setCreating(false); await onCreated?.(theme); }} />}
    {publishing && <ActivationModal show themes={themes.filter(theme => Number(theme.status) === 1)} defaultThemeId={themeId} defaultPlatform={2} defaultPage={sectionFor} onClose={() => setPublishing(false)} onSaved={() => { setPublishing(false); window.location.assign(`/admin/designs/themes?platform=2&page=${sectionFor}`); }} />}
  </>;
}
